import React, { type FunctionComponent } from 'react'
import { type Control, type FormContextValues } from 'react-hook-form'
import { CollectionsFormInput } from 'domains/collections/components/collections-form/components/form-input/CollectionsFormInput'
import { type CollectionsFormData } from 'domains/collections/components/collections-form/utils/collectionsForm.types'
import { CollectionsFormSection } from 'domains/collections/components/collections-form/components/form-section/CollectionsFormSection'
import { collectionsFormTestIds } from 'domains/collections/components/collections-form/utils/collectionsForm.utils'
import { CollectionsFormField } from 'domains/collections/components/collections-form/components/form-field/CollectionsFormField'
import { type CollectionTypeEnum } from 'domains/collections/api'
import { CollectionsDetailsActiveDates } from './CollectionsDetailsActiveDates'
import { CollectionsDetailsParent } from './CollectionsDetailsParent'
import { CollectionsDetailsWarehouse } from './CollectionsDetailsWarehouse'
import { CollectionsDetailsStatus } from './CollectionsDetailsStatus'

interface CollectionsDetailProps {
  register: FormContextValues<CollectionsFormData>['register']
  errors: FormContextValues<CollectionsFormData>['errors']
  getValues: FormContextValues<CollectionsFormData>['getValues']
  setValue: FormContextValues<CollectionsFormData>['setValue']
  disableFormFields: boolean
  control: Control<CollectionsFormData>
  collectionId: string
  retailerId?: string
  collectionType: CollectionTypeEnum
}

export const CollectionsDetails: FunctionComponent<CollectionsDetailProps> = ({
  register,
  errors,
  disableFormFields,
  setValue,
  getValues,
  control,
  retailerId,
  collectionId,
  collectionType,
}) => (
  <CollectionsFormSection titleId="collectionsDomain.collectionsForm.section.details">
    <CollectionsFormField>
      <CollectionsFormInput
        identifier="details.name"
        ref={register({ required: true })}
        labelId="collectionsDomain.collectionsForm.section.details.name"
        errors={errors}
        errorMessage="collectionsDomain.collectionsForm.form.fields.name.error.required"
        placeholderMessageId="collectionsDomain.collectionsForm.form.fields.name.placeholder"
        disabled={disableFormFields}
        data-testid={collectionsFormTestIds.nameField}
      />
    </CollectionsFormField>

    <CollectionsFormField>
      <CollectionsDetailsStatus
        retailerId={retailerId}
        register={register}
        setValue={setValue}
        getValues={getValues}
      />
    </CollectionsFormField>

    <CollectionsDetailsActiveDates register={register} setValue={setValue} getValues={getValues} />

    <CollectionsFormField>
      <CollectionsDetailsParent
        collectionId={collectionId}
        control={control}
        retailerId={retailerId}
        collectionType={collectionType}
      />
    </CollectionsFormField>

    {!retailerId && (
      <CollectionsDetailsWarehouse register={register} setValue={setValue} getValues={getValues} />
    )}
  </CollectionsFormSection>
)
